import React, { useContext } from 'react'
import {
  type LinearProgressMeterProps,
  LinearProgressMeter,
} from '@paypalcorp/pp-react'
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react'
import { formatMessage } from '../../../../utils/localization/format_worldready'

import * as styles from './collectedAmountProgress.css'

interface CollectedAmountProps {
  targetAmount?: {
    value: string
    currencyCode: string
  }
  collectedAmount?: {
    value: string
    currencyCode: string
  }
  formattedCollectedAmount: string
  formattedTargetAmount: string
  linearProgressMeterPropsOverride?: Partial<LinearProgressMeterProps>
}

const CollectedAmountProgress = (props: CollectedAmountProps) => {
  const {
    targetAmount,
    collectedAmount,
    formattedCollectedAmount,
    formattedTargetAmount,
    linearProgressMeterPropsOverride,
  } = props
  const worldReadyC = useContext(WorldReadyContext)
  const formattedTargetAmountMessage: string = formatMessage({
    worldReady: worldReadyC,
    contentId: `flatProgress.receivedOf`,
    formatOptions: { amount: formattedTargetAmount },
  })

  return (
    <LinearProgressMeter
      max={targetAmount.value}
      value={collectedAmount.value}
      steps={formattedCollectedAmount}
      title={formattedTargetAmountMessage}
      data-testid="datatestProgressBar"
      color="accent3"
      className={styles.progressBarPadding}
      {...(linearProgressMeterPropsOverride ?? {})}
    />
  )
}

export default CollectedAmountProgress
